import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from '@themesberg/react-bootstrap'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Wrapper } from './CompleteCheckoutWithEmail.styled'
import useSharedFunctions from '../../components/custom/Shared/SharedFunctions/SharedFunctions'
import useRequest from '../../axios/apis/useRequest'
import SafeFormatMessage from '../../components/custom/Shared/SafeFormatMessage/SafeFormatMessage'
import { cycle } from '../../const'
import { UppercaseMonthDateFormat } from '../../lib/sharedFun/Time'

const CompleteCheckoutWithEmail = ({ priceData }) => {
  const { getLocalizedString } = useSharedFunctions()
  const [orderID, setOrderID] = useState('')
  const [orderData, setOrderData] = useState()
  const [email, setEmail] = useState('')

  const direction = useSelector((state) => state.main.direction)
  const hash = window.location.hash
  const array = hash.split('#')
  const orderIDHash = array.find((element) => element.includes('order-'))

  const { getOrderByIdPublic, completeSubscriptionWithoutCharge } = useRequest()

  useEffect(() => {
    if (!orderIDHash) {
      return
    }
    setOrderID(orderIDHash.replace('order-', ''))
  }, [orderIDHash])

  useEffect(() => {
    if (!orderID || orderData) {
      return
    }
    ;(async () => {
      const order = await getOrderByIdPublic(orderID)
      setOrderData(order.data.data)
    })()
  }, [orderID])

  const handleSubmit = async () => {
    if (!orderID || !email) {
      return
    }
    const response = await completeSubscriptionWithoutCharge({ orderID, email })
    const navigationUrl = response?.data.data.navigationUrl
    if (navigationUrl) {
      const decodedUrl = decodeURIComponent(navigationUrl)
      window.location.href = decodedUrl
    }
  }

  return (
    <Wrapper>
      {orderData?.orderItems && (
        <section
          className="d-flex align-items-center"
          style={{ minHeight: '100vh' }}
        >
          <Container className="d-flex justify-content-center">
            <Card
              style={{
                height: '50vh',
                backgroundColor: 'var(--themeBackground)',
              }}
              className="w-75"
            >
              <Card.Body className="d-flex justify-content-center w-100">
                <Row>
                  <Col
                    md={5}
                    className="d-flex align-items-center justify-content-center border-right-1 border-light"
                  >
                    <div>
                      {orderData?.orderItems[0]?.trialPeriodInDays ? (
                        <>
                          <Card.Title className="mb-0">
                            <span
                              className="fw-bold"
                              style={{ color: 'var(--primary4)' }}
                            >
                              {priceData?.product?.displayNameLocalizations
                                ? getLocalizedString(
                                    priceData?.product?.displayNameLocalizations
                                  )
                                : priceData?.product?.displayName}
                            </span>
                            <div
                              style={{
                                color: 'var(--primary4)',
                                fontSize: 'var(--normalFont)',
                                fontWeight: 'normal',
                              }}
                            >
                              <SafeFormatMessage id="Try" />{' '}
                              <div className="fw-bold">
                                {orderData?.orderItems[0]?.displayName}
                              </div>
                            </div>
                            <div
                              className="fw-bold"
                              style={{
                                color: 'var(--second-color)',
                                fontSize: 'var(--hugeFont)',
                              }}
                            >
                              {orderData?.orderItems[0]?.trialPeriodInDays}{' '}
                              <SafeFormatMessage id="Days" />{' '}
                              <SafeFormatMessage id="Free" />
                            </div>
                          </Card.Title>
                          <span className="fw-bold">
                            <SafeFormatMessage id="Then" />{' '}
                            {orderData?.calculatedOrderTotal.formattedPrice}{' '}
                            {cycle[priceData?.cycle] && (
                              <SafeFormatMessage id={cycle[priceData?.cycle]} />
                            )}
                          </span>
                          <div
                            style={{
                              color: 'var(--primary4)',
                              fontSize: 'var(--normalFont)',
                              fontWeight: 'normal',
                            }}
                          >
                            {orderData?.orderItems[0]?.description}
                          </div>
                        </>
                      ) : (
                        <>
                          <span
                            className="fw-bold"
                            style={{ color: 'var(--primary4)' }}
                          >
                            {priceData?.product?.displayNameLocalizations
                              ? getLocalizedString(
                                  priceData?.product?.displayNameLocalizations
                                )
                              : priceData?.product?.displayName}
                          </span>
                          <div
                            style={{
                              color: 'var(--primary3)',
                              fontSize: 'var(--normalFont)',
                              fontWeight: 'normal',
                            }}
                          >
                            <SafeFormatMessage id="Start-With" />{' '}
                            {priceData?.plan.displayNameLocalizations
                              ? getLocalizedString(
                                  priceData?.plan.displayNameLocalizations
                                )
                              : priceData?.plan.displayName}
                          </div>
                          <div
                            className="fw-bold"
                            style={{
                              color: 'var(--second-color)',
                              fontSize: 'var(--hugeFont)',
                            }}
                          >
                            {orderData?.calculatedOrderTotal.formattedPrice}{' '}
                            {cycle[priceData?.cycle] && (
                              <SafeFormatMessage id={cycle[priceData?.cycle]} />
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </Col>
                  <Col
                    md={7}
                    className={`my-2 d-flex align-items-center justify-content-start  ${direction === 'ltr' ? 'pl-5' : 'pr-5'}`}
                  >
                    <div style={{ width: '100%' }}>
                      <Card.Title className="">
                        <SafeFormatMessage
                          id="Start-for-free"
                          defaultMessage={'Start for free'}
                        />
                      </Card.Title>
                      <Form.Group controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="mb-3"
                        />
                      </Form.Group>

                      <Card.Footer className="px-0 mb-0 h-100 d-flex justify-content-center">
                        <Button
                          variant="primary"
                          style={{
                            width: '100%',
                            padding: '10px',
                            fontSize: '16px',
                          }}
                          onClick={handleSubmit}
                        >
                          <SafeFormatMessage
                            id="Start-trial"
                            defaultMessage={'Start trial'}
                          />
                        </Button>
                      </Card.Footer>
                      <p
                        style={{
                          color: 'gray',
                          fontSize: 'small',
                          textAlign: 'center',
                        }}
                      >
                        <SafeFormatMessage
                          id="Your-trial-will-end-on"
                          defaultMessage={'Your trial will end on'}
                        />{' '}
                        <span className="fw-bold">
                          {UppercaseMonthDateFormat(
                            orderData?.orderItems[0]?.endDate
                          )}
                        </span>
                        .{' '}
                        <SafeFormatMessage
                          id="You-can-always-cancel-before-then"
                          defaultMessage={'You can always cancel before then.'}
                        />
                      </p>
                      <div
                        className="copy"
                        style={{ color: 'var(--primary4)' }}
                      >
                        Powered by <span className="yellow">@</span>
                        <span className="fw-bold">RoSaaS</span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </section>
      )}
    </Wrapper>
  )
}

export default CompleteCheckoutWithEmail
